module.exports = __webpack_public_path__ + "img/slika21.2ad37226.jpg";